import { PATH } from "./path";
import { ApiFindOptions, useApiFind } from "../../../HttpService";

export const useFindPatents = (options: ApiFindOptions = {}) => useApiFind<any>(PATH, options);
